import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/store";
import { HelmetProvider } from "react-helmet-async";
import axios from "axios";

// Global Axios Interceptor for Caching GET requests
axios.interceptors.request.use(
  (config) => {
    if (config.method === "get") {
      const key = `cache_${config.url}_${JSON.stringify(config.params || {})}`;
      const cachedData = sessionStorage.getItem(key);
      if (cachedData) {
        config.adapter = () =>
          Promise.resolve({
            data: JSON.parse(cachedData),
            status: 200,
            statusText: "OK",
            headers: {},
            config,
            request: {},
          });
      }
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axios.interceptors.response.use(
  (response) => {
    if (response.config.method === "get") {
      const key = `cache_${response.config.url}_${JSON.stringify(response.config.params || {})}`;
      try {
        sessionStorage.setItem(key, JSON.stringify(response.data));
      } catch (e) {
        console.warn("Session storage quota exceeded or unavailable");
      }
    }
    return response;
  },
  (error) => Promise.reject(error),
);

const rootElement = document.getElementById("root");

const AppTree = (
  <HelmetProvider>
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </HelmetProvider>
);

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, AppTree);
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(AppTree);
}

reportWebVitals();
